import React, { Component } from 'react'
import smileIcon from './../../assets/img/smile.svg'
export class Card extends Component {
    render() {
        const { classes , title , short_dec:shortDesc , image:img  } = this.props
        return (
            <div className={classes}>
                <div className="card h-full neo-out rounded-md">
                    <div className='card__header flex-row '>
                        <img className="w-[25px] h-[25px]" src={`http://${img}`} alt="" />
                        <span className='card__title ml-3'>{title}</span>

                    </div>
                    <div className="card__body">
                        <span className='card__desc'>
                            {shortDesc}
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}

export default Card